import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'facetOptionFilter',
})
export class FacetOptionFilterPipe implements PipeTransform {
  transform(items: any[], searchText: string | null): any[] {
    if (!items) return [];
    if (!searchText) return items;
    searchText = searchText.toLowerCase();
    return items.filter((it) => {
      return it.key.toLowerCase().includes(searchText);
    });
  }
}
